import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { ButtonProps, ButtonTypes } from '../Button';
import { Button } from '../Button';
import type { ButtonSubmitTypes, ExternalLinkTypes, LinkTypes } from '../Button/Button';
import { Tooltip } from '../Tooltip';

export type IconButtonProps =
    | (Omit<ButtonTypes, 'iconEnd' | 'iconStart' | 'children'> & {
          type?: 'button';
          icon: IconDefinition;
          label: string;
      })
    | (Omit<ButtonSubmitTypes, 'iconEnd' | 'iconStart' | 'children'> & {
          type?: 'submit';
          icon: IconDefinition;
          label: string;
      })
    | (Omit<LinkTypes, 'iconEnd' | 'iconStart' | 'children'> & { type?: 'link'; icon: IconDefinition; label: string })
    | (Omit<ExternalLinkTypes, 'iconEnd' | 'iconStart' | 'children'> & {
          type?: 'external-link';
          icon: IconDefinition;
          label: string;
      });

export const IconButton = (props: IconButtonProps) => {
    const { icon, label, ...rest } = props;
    const buttonProps = { ...rest, htmlAttributes: { 'aria-label': label, ...rest.htmlAttributes } } as ButtonProps;
    const button = (
        <Button
            size='small'
            {...buttonProps}
        >
            <FontAwesomeIcon icon={icon} />
        </Button>
    );

    return <div data-component-name='IconButton'>{label ? <Tooltip content={label}>{button}</Tooltip> : button}</div>;
};
